import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Button,
  Typography,
  TableContainer,
  TablePagination,
  IconButton
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useSettingContext } from '../../context/setting_context';
import { baseUrl } from '../../utils/constants';
import { ClientListHead, ClientListToolbar } from '../_dashboard/clients';

const TABLE_HEAD = [
  { id: 'templateName', label: 'Name', alignRight: false },
  { id: 'referenceName', label: 'Reference', alignRight: false },
  { id: 'notificationType', label: 'Type', alignRight: false },
  { id: 'reference', label: 'Reference', alignRight: false },
  { id: 'status', label: 'State', alignRight: false },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_template) => _template.templateName.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function TemplateList() {
  const { setCurrentTemplate } = useSettingContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderBy, setOrderBy] = useState('name');
  const [sortOrder, setSortOrder] = useState(true);
  const [skip, setSkip] = useState(300);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [category, setCategory] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    populateTemplateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = templateList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleTemplateView = async (e) => {
    console.log('selected template', e);
    const parent = e.row.parentRefId ?? '';
    await fetch(
      `${baseUrl}/api/Setting/GetNotificationTemplate?refId=${
        e.row.templateId
      }&create=${false}&parentrefid=${parent}`
    )
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned single template', res);
          setCurrentTemplate(res);
          setLoading(false);
        },
        (error) => {
          alert(`failed here ${{ error }}`);
        }
      );

    navigate('/settings/edittemplate');
  };

  const populateTemplateList = async () => {
    try {
      const load = {
        page,
        skip,
        orderBy,
        order: sortOrder,
        filter: filterName
      };
      if (category === 0) {
        await fetch(
          `${baseUrl}/api/Setting/GetNotificationTemplates?step=${page}&skip=${skip}&orderBy=${orderBy}&order=${sortOrder}&filter=${filterName}`
        )
          .then((res) => res.json())
          .then(
            (res) => {
              console.log('returned list 1', res);
              setTemplateList(res.items);
              setLoading(false);
            },
            (error) => {
              alert(`failed here ${{ error }}`);
            }
          );
      } else {
        await fetch(
          `${baseUrl}/api/Settings/GetNotificationTemplates?step=" + ${page} + "&skip=" + ${skip} + "&orderBy=" + ${orderBy} + "&order=" + ${sortOrder} + "&filter=" + ${filterName} + "&category=" + ${category}`
        ).then(
          (res) => {
            console.log('returned list 2', res);
            setTemplateList(res.items);
            setLoading(false);
          },
          (error) => {
            alert(`failed here ${{ error }}`);
          }
        );
      }
    } catch (e) {
      alert(`failed here ${{ e }}`);
    }
  };

  const handleNewTemplate = () => {
    openNew();
  };

  const openNew = (e) => {
    navigate('/dashboard/newtemplate');
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - templateList.length) : 0;

  const filteredUsers = applySortFilter(templateList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Communication Templates...
      </Typography>
      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => handleNewTemplate()}
      >
        Add New
      </Button>
      <Card>
        <ClientListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
        />

        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <ClientListHead
              order={order}
              orderBy={orderBy}
              headLabel={TABLE_HEAD}
              rowCount={templateList.length}
              numSelected={selected.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
            />
            <TableBody>
              {filteredUsers
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const {
                    templateId,
                    templateName,
                    referenceName,
                    notificationType,
                    reference,
                    status
                  } = row;
                  const isItemSelected = selected.indexOf(templateName) !== -1;

                  return (
                    <TableRow
                      hover
                      key={templateId}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell padding="checkbox" />
                      <TableCell align="left">{templateName}</TableCell>
                      <TableCell align="left">{referenceName}</TableCell>
                      <TableCell align="left">{notificationType}</TableCell>
                      <TableCell align="left">{reference}</TableCell>
                      <TableCell align="left">{status}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => handleTemplateView({ templateId })}>
                          <ThumbUpAltIcon sx={{ color: '#76ff03' }} />
                        </IconButton>
                        <IconButton>
                          <ThumbDownAltIcon sx={{ color: '#f44336' }} />
                        </IconButton>
                        <IconButton onClick={() => handleTemplateView({ row })}>
                          <VisibilityIcon sx={{ color: '#03a9f4' }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {isUserNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={templateList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
    // </Page>
  );
}
